<template id="deleteform">
  <v-card v-click-outside="changeFalse">
    <v-card-title class="bg-grey-lighten-2 text-primary">
      {{ t('accountDelete.title') }}
    </v-card-title>

    <v-form ref="delete-modal" v-if="!isActive">
      <v-card-text class="py-3">
        <div style="margin-bottom: 20px;font-size: 12px; line-height: 14px;">
          <p>
            {{ t('accountDelete.description.line1') }}<br>
          </p>
        </div>
        <div class="del">
          <p class="del_p">
            ・{{ t('accountDelete.items.records') }} <br>
            ・{{ t('accountDelete.items.chat') }} <br>
            ・{{ t('accountDelete.items.growth') }} <br>
            <!-- ・{{ t('accountDelete.items.invoices') }} <br>
            ・<strong>{{ t('accountDelete.items.memoru') }}</strong> -->
          </p>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="error" variant="text">{{ t('common.cancel') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="changeTrue" color="primary" variant="flat">
          {{ t('accountDelete.continue') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-form>

    <v-form v-if="isActive">
      <v-card-text class="py-3">
        <div style="margin: 0 auto 10px auto; text-align: center;">
          <p>{{ t('accountDelete.reasonPrompt') }}</p>
        </div>
        <v-textarea
          v-model="comment"
          :rules="[rules.required]"
          label=""
          auto-grow
          variant="outlined"
          density="compact" />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="error" variant="text">{{ t('common.cancel') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-bind:disabled="!comment" @click="del" :loading="btnLoading" color="primary">
          {{ t('common.delete') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-form>
    
  </v-card>

</template>
<script lang="ts">
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import rules from '@/service/ValidRules';
import { t, locale } from '@/i18n';
dayjs.locale(locale);

import { auth0Module } from '@/store/entityModules/auth0';
import { parentModule } from '@/store/entityModules/parent';

// model
import { VForm } from '@/model/Vuetify/VForm';
import { PostHomeAbsenceRequest } from '@/model/Chat';

interface DataType {
  comment: string | null;
  btnLoading: boolean;
  isActive:boolean;
}

export default defineComponent({
  name: 'DeleteModal',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: Number,
      default: undefined,
    },
  },

  computed: {
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).delete_form;
    },
    allowMinDate(): string {
      return dayjs().format('YYYY-MM-DD');
    },

  },

  watch: {
    isOpen: {
      async handler(val: boolean) {
        if (val) {
          this.comment = null;
        }
      },
      deep: true,
    },
  },

  data: (): DataType => ({
    comment: '',
    btnLoading: false,
    isActive:false,
  }),

  methods: {
    t,
    close() {
      this.$emit('close');
      this.isActive = false;
    },
    changeTrue() {
      this.isActive = true;
    },
    changeFalse() {
      this.isActive = false;
    },
    del(){
      this.$emit('close');
      this.$emit('del');
      this.isActive = false;
      auth0Module.logout();
    },
  },

  async mounted() {},
});
</script>
<style lang="scss" scoped>
.del {
  width: 180px;
  height: auto;
  margin: auto;
  padding: 10px;
  background-color: rgb(240, 248, 255); 
  display: block; 
  text-align: center;
  border-radius: 7px;
}
.del_p {
  font-size: 12px;
  line-height: 14px;
  position: relative;
  top: 10%;
  display: inline-block;
  text-align: left;
}
</style>
